
const state = {
  locale: null,
  showUserMenu: false,
  appConfig: [],
}

const getters = {
  locale: state => state.locale,
  showUserMenu: state => state.showUserMenu,
  appConfig: state => state.appConfig
}

const actions = {
  switchLocale({commit}, { locale }) {
    commit('setLocale', locale)
  },
  showUserMenu({commit}, { showUserMenu }) {
    commit('setUserMenu', showUserMenu)
  },
  appConfig({commit}, { appConfig }) {
    commit('configApp', appConfig)
  },
}

const mutations = {
  setLocale(state, locale){
    state.locale = locale
  },
  setUserMenu(state, showUserMenu){
    state.showUserMenu = showUserMenu
  },
  configApp(state, appConfig){
    state.appConfig = appConfig
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}